<template>
  <Dialog v-if="isShow" class="_components-online-notice-dialog" title="重要通知" :clickOverlayClose="hasClose" :iClose="hasClose" @close="handleClose">
    <p class="text1 color-gray-1 mt-6 text-indent">
      2022年HSYLC峰会，将会延续疫情以来作为最大规模国际交流活动的丰富经验，以云端无国界峰会的形式，如期和大家见面，并将在峰会期间根据疫情防控要求，举办同城小组交流活动，开放三场所有嘉宾大师课和世界名校招生官活动，为同学们创造更多元的可能性。
    </p>
    <Button class="btn" v-if="hasBtn" @click="handleSubmitBtn">查看通知全文</Button>
  </Dialog>
</template>
<script>
/**
 * @module OnlineNoticeDialog
 * @desc 峰会转线上通知弹窗
 */
import Dialog from '../Dialog';
import { Button } from '../form';
import { Api, Codes } from '@/api';
export default {
  name: 'OnlineNoticeDialog',
  components: {
    Dialog,
    Button
  },
  /**
   * @member { Boolean } isShow 是否开启
   * @member { Boolean } hasBtn 是否有我已知悉按钮
   * @member { Boolean } hasClose 是否显示关闭icon
   */
  data() {
    return {
      isShow: false,
      hasBtn: true,
      hasClose: true
    };
  },
  methods: {
    /**
     * @function handleClose
     * @desc 关闭弹窗
     */
    handleClose() {
      this.isShow = false;
    },
    /**
     * @function handleOpen
     * @desc 打开弹窗
     */
    handleOpen() {
      this.isShow = true;
    },
    async handleSubmitBtn() {
      this.$loading.show();
      this.$windowOpen('/notice/online-notice');
      const res = await Api.post.postStudentOfflineToOnline();
      if (res.status === Codes.SUCCESS) {
        this.isShow = false;
      }
      this.$loading.hide();
    }
  }
};
</script>
<style lang="less" scoped src="./index.less"></style>
